import Vue from 'vue'
import App from './App.vue'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';



import router from './router.js'
import '@/config/rem.js'

import store from './store/index'

// import { quillEditor } from 'vue-quill-editor'
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
// import '@/assets/css/quill.bubble.css'
// import '@/assets/css/quill.core.css'
// import '@/assets/css/quill.snow.css'


import http from './http'
Vue.prototype.http = http 

// 引入api
// import api from '@/api'
// Vue.prototype.$_api = api



Vue.config.productionTip = false
Vue.use(ElementUI)

new Vue({
  router,
  store,
  // quillEditor,
  render: h => h(App),
}).$mount('#app')
